module.exports = __webpack_public_path__ + "static/media/c6798d4ec030ba2afe9a7080ca6a6270.9605e8e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/posters/c6798d4ec030ba2afe9a7080ca6a6270.jpg
// module id = 268
// module chunks = 0